export default __webpack_public_path__ + "static/media/culture_EP4.954d25cd.png";